import { Box, TextField, Typography } from "@mui/material";
import { FormEvent, useMemo, useState } from "react";
import MainWrapper from "../component/MainWrapper";
const MAX_REASON_WORDS = 2000;
const countWords = (value: string) =>
  value.trim() ? value.trim().split(/\s+/).length : 0;
const DeleteRequest = () => {
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [reason, setReason] = useState("");
  const [errors, setErrors] = useState({ email: "", phone: "", reason: "" });
  const reasonWordCount = useMemo(() => countWords(reason), [reason]);
  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const nextErrors = {
      email:
        email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
          ? "Enter a valid email address"
          : "",
      phone: phone.trim() ? "" : "Phone number is required",
      reason: !reason.trim()
        ? "Reason is required"
        : reasonWordCount > MAX_REASON_WORDS
        ? `Reason cannot exceed ${MAX_REASON_WORDS} words`
        : "",
    };
    setErrors(nextErrors);
    if (Object.values(nextErrors).some(Boolean)) return;
    const message = [
      "Delete Request",
      "",
      `Email: ${email.trim() || "Not provided"}`,
      `Phone number: ${phone.trim()}`,
      "",
      "Reason:",
      reason.trim(),
    ].join("\n");
    const mailtoUrl = `mailto:skuvahn@gmail.com?subject=${encodeURIComponent(
      "Delete Request"
    )}&body=${encodeURIComponent(message)}`;

    window.location.href = mailtoUrl;
  };
  return (
    <>
      <MainWrapper
        label="Submit"
        submitHandler={handleSubmit}
        buttonClassName="submit-request-button"
      >
        <Box>
          <Box mt={3} mb={2}>
            <Typography className="f-30">Delete Request</Typography>
            <Typography color="text.secondary" mt={1}>
              Submit a request to delete your account information.
            </Typography>
          </Box>
          <Box display="flex" flexDirection="column" gap={2}>
            <TextField
              label="Email address (optional)"
              type="email"
              value={email}
              error={Boolean(errors.email)}
              helperText={errors.email}
              onChange={(event) => {
                setEmail(event.target.value);
                setErrors((current) => ({ ...current, email: "" }));
              }}
              fullWidth
            />
            <TextField
              label="Phone number"
              type="tel"
              value={phone}
              error={Boolean(errors.phone)}
              helperText={errors.phone}
              onChange={(event) => {
                setPhone(event.target.value);
                setErrors((current) => ({ ...current, phone: "" }));
              }}
              required
              fullWidth
            />
            <TextField
              label="Reason"
              value={reason}
              error={Boolean(errors.reason)}
              helperText={
                errors.reason ||
                `${reasonWordCount} / ${MAX_REASON_WORDS} words`
              }
              onChange={(event) => {
                setReason(event.target.value);
                setErrors((current) => ({ ...current, reason: "" }));
              }}
              multiline
              minRows={6}
              required
              fullWidth
            />
          </Box>
        </Box>
      </MainWrapper>
    </>
  );
};
export default DeleteRequest;
